import { render, staticRenderFns } from "./dailyConfiguration.vue?vue&type=template&id=54885ae6&scoped=true"
import script from "./dailyConfiguration.vue?vue&type=script&lang=js"
export * from "./dailyConfiguration.vue?vue&type=script&lang=js"
import style0 from "./dailyConfiguration.vue?vue&type=style&index=0&id=54885ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54885ae6",
  null
  
)

export default component.exports